import React, { useEffect, useState } from 'react';
import { words } from 'lodash';
import { Banner } from 'components/atoms/banner';
import { FooterExploreButton } from 'components/atoms/footerExploreButton';
import { useViewport } from 'components/templates/viewportProvider';
import { StringUtil } from 'utils/StringUtil';
import { HTMLView } from 'components/atoms/htmlView';
import InstagramIcon from 'assets/images/Social-v1_insta.png';
import InstagramIconHover from 'assets/images/Social-v1_insta_hover.png';
import FaceBookIcon from 'assets/images/Social-v1_facebook.png';
import FacebookIconHover from 'assets/images/Social-v1_fb_hover.png';
import TwitterIcon from 'assets/images/Social-v1_twitter.png';
import TwitterIconHover from 'assets/images/Social-v1_twitter_hover.png';
import Marker from 'assets/images/marker.png';
import ArrowLongCoral from 'assets/images/arrowLongRightHighlight.png';
import ArrowRightCoral from 'assets/images/RIGHT.png';
// eslint-disable-next-line
import styles from "./styles.scss";

const DiningDetailsBanner = props => {
  const { height, isMobile } = useViewport();
  const { theme, currentRestaurantOutlet } = props;
  const { banner } = props.data;

  const {
    description,
    city,
    area,
    phone,
    isTodayClose,
    timings,
    currentStatus,
    address,
    facebookLink,
    instagramLink,
    twitterLink,
    desktop_carousal_data,
    carousal_mobile_data,
  } = banner[0];
  let carousal_data = isMobile ? carousal_mobile_data : desktop_carousal_data;

  let className = 'dining-details-banner';
  let contactCardClass = 'contact-card';
  let contactCardContainer = 'contact-visit-card-link';
  if (isMobile) {
    // TODO: for mobile
    // const bannerImageUrl = `${path}${mobile}/${banner.image_mobile}`;
    contactCardClass = 'contact-card-mobile';
    contactCardContainer = 'contact-visit-card-link-mobile';
  }
  const countLengthOf = StringUtil.sliceHtml(description);
  const length = words(countLengthOf).length;
  const [socialIcons, setSocialIcons] = useState({
    faceBook: facebookLink,
    instagram: instagramLink,
    twitter: twitterLink,
  });

  useEffect(() => {
    const socialIconsObject = {
      faceBook: facebookLink,
      instagram: instagramLink,
      twitter: twitterLink,
    };
    setSocialIcons(socialIconsObject);
  }, [facebookLink, instagramLink, twitterLink]);

  const socialIcon = (hovered, icon) => {
    return !isMobile ? hovered : icon;
  };

  const renderOutletSocialIcons = () => {
    return (
      <div className={'outlet-social-icons'}>
        {socialIcons && socialIcons.instagram && (
          <div
            className={'icon-container'}
            onClick={() => socialLinkNavigation(socialIcons.instagram)}
          >
            <img
              src={InstagramIcon}
              alt="instagram-icon-failed"
              onMouseOver={e =>
                (e.currentTarget.src = socialIcon(
                  InstagramIconHover,
                  InstagramIcon
                ))
              }
              onMouseLeave={e => (e.currentTarget.src = InstagramIcon)}
            />
          </div>
        )}
        {socialIcons && socialIcons.faceBook && (
          <div
            className={'icon-container'}
            onClick={() => socialLinkNavigation(socialIcons.faceBook)}
          >
            <img
              src={FaceBookIcon}
              alt="facebook-icon-failed"
              onMouseOver={e =>
                (e.currentTarget.src = socialIcon(
                  FacebookIconHover,
                  FaceBookIcon
                ))
              }
              onMouseLeave={e => (e.currentTarget.src = FaceBookIcon)}
            />
          </div>
        )}
        {socialIcons && socialIcons.twitter && (
          <div
            className={'icon-container'}
            onClick={() => socialLinkNavigation(socialIcons.twitter)}
          >
            <img
              src={TwitterIcon}
              alt="twitter-icon-failed"
              onMouseOver={e =>
                (e.currentTarget.src = socialIcon(
                  TwitterIconHover,
                  TwitterIcon
                ))
              }
              onMouseLeave={e => (e.currentTarget.src = TwitterIcon)}
            />
          </div>
        )}
      </div>
    );
  };

  const renderDescription = () => {
    if (!isMobile) {
      return (
        <HTMLView
          className={'restaurant-detail-description'}
          html={description}
          tagName={'p'}
        />
      );
    }
    return null;
  };

  let address_desktop = `${address}${area ? ', ' : ''}${area}${
    city ? ', ' : ''
  }${city}`;
  let address_mobile = `${address}${area ? ', ' : ''}${area ? area : ''}`;

  const renderContactCard = () => {
    return (
      <div className={contactCardContainer}>
        <div className={contactCardClass}>
          <div className={'content-container'}>
            <div className={'location-container'}>
              {isMobile ? (
                <>
                  <img
                    className={'location-marker'}
                    src={Marker}
                    alt={'location'}
                  />
                  <span className={'address'}>{address_mobile}</span>
                </>
              ) : (
                <span className={'address'}>{address_desktop}</span>
              )}
            </div>
            <div className={'social-lower-div'}>
              <div className={'timing-container'}>
                <span className={'phone-number'}>{phone}</span>
                <div className={'secondary-info'}>{restaurantTimings()}</div>
              </div>
              <div className={'social-div'}>
                {isMobile ? (
                  <div className={'about-button-mobile'}>
                    <a className={'section-footer-item'} href={'#team'}>
                      <button className={'section-footer-item'}>
                        <span>About Us</span>
                        <img src={ArrowRightCoral} alt={'arrow'} />
                      </button>
                    </a>
                  </div>
                ) : (
                  ''
                )}
                {isMobile && socialIcons ? renderOutletSocialIcons() : ''}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const restaurantTimings = () => {
    if (isMobile) {
      return (
        <div className={'restaurant-timings'}>
          {!isTodayClose ? (
            <>
              <div>{currentStatus}</div>
              <div>{timings}</div>
            </>
          ) : (
            <>
              <div>CLOSED TODAY</div>
              {/*<div>OPENS AT&nbsp;{opens_at}</div>*/}
            </>
          )}
        </div>
      );
    } else {
      return (
        <span>
          {currentStatus},&nbsp;&nbsp;{timings}
        </span>
      );
    }
  };

  const socialLinkNavigation = socialLink => {
    if (socialLink) {
      window.open(socialLink);
    }
  };

  const showCarousalLength = () => {
    return carousal_data.length > 1;
  };

  return (
    <div className={className} style={{ height }} id={'banner'}>
      <Banner
        imageUrl={
          !showCarousalLength()
            ? isMobile
              ? carousal_data[0].mobile_image
              : carousal_data[0].image
            : ''
        }
        thumbNailUrl={
          !showCarousalLength()
            ? isMobile
              ? carousal_data[0].mobile_image
              : carousal_data[0].thumbnail
            : ''
        }
        title={!showCarousalLength() ? carousal_data[0].title : ''}
        length={length}
        containerClassName={'restaurant-detail'}
        description={renderDescription()}
        socialIcons={renderOutletSocialIcons()}
        imageId={currentRestaurantOutlet ? currentRestaurantOutlet : 0}
        isCarousal={showCarousalLength()}
        carousal_data={carousal_data}
      />
      {renderContactCard()}
      {isMobile && (
        <FooterExploreButton
          theme={theme}
          onClick={() => {}}
          sectionName={'menu'}
        />
      )}
      {!isMobile ? (
        <div className={'about-button'}>
          <a className={'section-footer-item'} href={'#team'}>
            <span>About Us</span>
            <img src={ArrowLongCoral} alt={'arrow'} />
          </a>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default DiningDetailsBanner;
